import SolidGeometry, { prismGeometry } from "./solid-geometry";

// Prisma trapezoidal: base inferior com a largura total e superior com 3/4 dela
export default class TrapezeGeometry extends SolidGeometry {
  constructor(color, { width, height, depth }, positions) {
    const w = width / 2;
    const h = height / 2;
    const geometry = prismGeometry(
      [[-w, -h], [w, -h], [0.75 * w, h], [-0.75 * w, h]],
      depth
    );
    super("trapeze", color, geometry, positions);
  }
}
